import styled from 'styled-components';

export const DivFormTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ExpandPainelContainer = styled.div`
  padding: 0px;
  display: initial;
  .MuiButtonBase-root {
    cursor: default;
  }
  .MuiAccordionSummary-content {
    cursor: default;
    display: initial;
    margin: 0px 0px 60px 0px;
    padding: 0px 10px 0px 10px;
  }
  .MuiAccordion-root {
    background-color: #f5f5f5;
  }
  .MuiAccordionDetails-root {
    display: initial;
    margin-top: -20px;
  }
  .MuiAccordionSummary-root {
    margin-bottom: -40px;
  }
  .MuiCollapse-wrapper {
    margin-top: 0px;
    padding: 0px 25px 0px 25px;
  }
  .MuiAccordion-rounded {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    box-shadow: none;
  }
`;

export const ExpandPainelItemContainer = styled.div`
  margin-bottom: 10px;
`;

export const ExpandPainelItemLabel = styled.p`
  font-size: 0.8rem;
  color: #999;
  margin-bottom: 5px;
`;

